import { ReferenceField } from "@/components/admin";
import type { Identifier } from "ra-core";
import {
  useGetRecordRepresentation,
  useRecordContext,
  useTranslate,
} from "ra-core";
import type { Task } from "../types";
import { EditSheet } from "../misc/EditSheet";
import { TaskFormContent } from "./TaskFormContent";

export interface TaskEditSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  taskId: Identifier;
}

export const TaskEditSheet = ({
  open,
  onOpenChange,
  taskId,
}: TaskEditSheetProps) => {
  return (
    <EditSheet
      resource="tasks"
      id={taskId}
      title={<TaskEditSheetTitle />}
      redirect={false}
      open={open}
      onOpenChange={onOpenChange}
    >
      <TaskFormContent />
    </EditSheet>
  );
};

/** "Editar tarea de Lucía", or just "Editar tarea" for an internal task. */
const TaskEditSheetTitle = () => {
  const translate = useTranslate();
  const getContactRepresentation = useGetRecordRepresentation("contacts");
  const task = useRecordContext<Task>();
  const plain = (
    <span className="text-xl font-semibold truncate pr-10">
      {translate("resources.tasks.sheet.edit")}
    </span>
  );
  if (task?.contact_id == null) return plain;
  return (
    <ReferenceField
      source="contact_id"
      reference="contacts"
      render={({ referenceRecord }) =>
        referenceRecord ? (
          <span className="text-xl font-semibold truncate pr-10">
            {translate("resources.tasks.sheet.edit_for", {
              name: getContactRepresentation(referenceRecord),
            })}
          </span>
        ) : (
          plain
        )
      }
    />
  );
};
